import Button from './Button';
import ThemeToggle from './ThemeToggle';

interface HeaderProps {
  onSearchChange?: (query: string) => void;
  searchQuery?: string;
  onAddBookmark?: () => void;
  showSearch?: boolean;
}

export default function Header({ onSearchChange, searchQuery = '', onAddBookmark, showSearch = true }: HeaderProps) {
  // Detect if user is using Firefox
  const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.includes('Firefox');
  
  const handleFirefoxDownload = () => {
    window.open('https://addons.mozilla.org/en-US/firefox/addon/save-for-later-pro/?utm_source=sfl_web&utm_medium=referral&utm_content=click', '_blank');
  };
  return (
    <header className="fixed top-0 left-64 right-0 bg-[var(--color-background-paper)] border-b border-[var(--color-neutral-light-gray)] shadow-sm z-50">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {showSearch && (
            <div className="flex-1 max-w-2xl">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search bookmarks..."
                  value={searchQuery}
                  onChange={(e) => onSearchChange?.(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 rounded-lg bg-[var(--color-background)] border border-[var(--color-neutral-light-gray)] text-[var(--color-text)] placeholder-[var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent transition-colors"
                />
                <svg
                  className="absolute left-3 top-2.5 w-5 h-5 text-[var(--color-text-tertiary)]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          )}

          <div className="flex items-center space-x-4 ml-4">
            {isFirefox && (
              <Button
                variant="secondary"
                onClick={handleFirefoxDownload}
                className="flex items-center bg-orange-500 hover:bg-orange-600 text-white"
                leftIcon={
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                }
              >
                Get Firefox Extension
              </Button>
            )}
            <Button
              variant="primary"
              onClick={onAddBookmark}
              className="flex items-center"
              leftIcon={
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
              }
            >
              Add Bookmark
            </Button>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
}
